import clsx from 'clsx';
import { observer } from 'mobx-react';
import * as React from 'react';
import ScrollToTop from '../../../../../../ScrollToTop';
import { T } from '../../../../../../Translations';
import ArrowLeftIcon from '../../../CurrentCollectionStep/Builder/ExperienceCatalog/ModalBodySelecting/ArrowLeftIcon';
import FiltersWithLearningCollections from './FiltersWithLearningCollections';
import LearningCollectionEditStore from '../../Store';
import { ChoosingLearningDesigns } from '../../Store/Types';

interface Props {
  store: LearningCollectionEditStore;
  state: ChoosingLearningDesigns;
}

const ChooseLearningDesign: React.FC<Props> = ({ store, state }) => (
  <div>
    <ScrollToTop />
    <button
      className={clsx('mx-10 flex items-center mt-8 mb-4 text-xl font-semibold text-gray-900')}
      onClick={store.building}
    >
      <div className="w-4">
        <ArrowLeftIcon />
      </div>
      <div className="pl-4">
        <T kind="Back to Builder" />
      </div>
    </button>
    <FiltersWithLearningCollections
      store={store}
      browseCatalog={state.learningCollectionEditFormResource.payload.browseCatalog}
    />
  </div>
);

export default observer(ChooseLearningDesign);
